import { useState } from 'react';
import CharCount from '../../charCount/CharCount';
import NestedTags from '../../nestedTags/NestedTags';
import Installment from '../../installment/Installment';
import './fixedPrice.css';
import { toast } from 'react-toastify';

export default function FixedPrice({ priceCount, packData, cityDrop, handlePrice, setPackData }) {
    const [vehicle, setVehicle] = useState({ name: '', price: 0 });
    const vehicles = [
        { displayName: 'Bike', name: 'Bike Rent' },
        { displayName: 'Car', name: 'Car Rent' }
    ];
    const [selectedVehicles, setSelectedVehicles] = useState([]);
    function addVehicle(index) {
        if (vehicle.name === '') {
            toast.error('Please enter the vehicle name');
        } else if (vehicle.price === 0) {
            toast.error('Please enter the vehicle price');
        }
        //  else if (!mapUrlPattern.test(pickup.location)) {
        //     alert('Enter proper map location URL');
        // }
        else {
            setPackData(function (prevState) {
                const updatedArrya = prevState.price.map(function (item, itemKey) {
                    if (index === itemKey) {
                        return {
                            ...item,
                            vehicle: [...(item.vehicle || []), vehicle]
                        };
                    }
                    return item;
                });
                return { ...prevState, price: [...updatedArrya] };
            });
            setSelectedVehicles([...selectedVehicles, vehicle.name]);
            setVehicle({ name: '', price: 0 });
        }
    }

    function removeVehicle(text, index) {
        // const tempArray = packData.price[index].pickupLocation;
        // let index = tempArray.indexOf(text);
        // tempArray.splice(index, 1);
        setPackData(function (prevState) {
            console.log('1');
            const updatedArrya = prevState.price.map(function (item, itemKey) {
                if (index === itemKey) {
                    const tempArray = [...item.vehicle];
                    const textIndex = tempArray.indexOf(text);
                    tempArray.splice(textIndex, 1);
                    console.log(tempArray);
                    return { ...item, vehicle: [...tempArray] };
                }
                return item;
            });
            return { ...prevState, price: [...updatedArrya] };
        });
    }
    return (
        <>
            {Array.apply(null, { length: priceCount }).map(function (_, itnKey) {
                return (
                    <div key={itnKey}>
                        <p className='itineraryLabel'>City {itnKey + 1}</p>
                        <div className='itineraryInDiv'>
                            <label className='itineraryLabel'>Actual Price</label>
                            <div className='itineraryInputDiv'>
                                <input
                                    value={packData.price[itnKey]?.price?.actual || null}
                                    type='number'
                                    name='actual'
                                    onChange={(e) => handlePrice(e, itnKey)}
                                    placeholder={`Actual Price for city ${itnKey + 1} `}
                                    className='itineraryInput'
                                ></input>
                                <CharCount
                                    string={packData.price[itnKey] ? String(packData.price[itnKey].price.actual) : ''}
                                    min={2}
                                    limit={7}
                                />
                            </div>
                        </div>
                        <div className='itineraryInDiv'>
                            <label className='itineraryLabel'>Tax</label>
                            <div className='itineraryInputDiv'>
                                <input
                                    value={packData.price[itnKey]?.price?.tax ?? 0}
                                    type='number'
                                    name='tax'
                                    onChange={(e) => handlePrice(e, itnKey)}
                                    placeholder={`Tax for city ${itnKey + 1} `}
                                    className='itineraryInput'
                                ></input>
                            </div>
                        </div>
                        <div className={`itineraryInDiv`}>
                            <label className='itineraryLabel'>Total</label>
                            <div className='itineraryInputDiv'>
                                <input
                                    value={packData.price[itnKey]?.price?.total ?? 0}
                                    type='number'
                                    name='total'
                                    onChange={(e) => handlePrice(e, itnKey)}
                                    placeholder={`Total Price for city ${itnKey + 1} `}
                                    className='itineraryInput'
                                ></input>
                            </div>
                        </div>
                        <div className='itineraryInDiv'>
                            <label className='itineraryLabel'>Reserve</label>
                            <div className='itineraryInputDiv'>
                                <input
                                    value={packData.price[itnKey]?.price?.reserve || null}
                                    type='number'
                                    name='reserve'
                                    onChange={(e) => handlePrice(e, itnKey)}
                                    placeholder={`Reserve for city ${itnKey + 1} `}
                                    className='itineraryInput'
                                ></input>
                                <CharCount
                                    string={
                                        packData.price[itnKey].price.reserve
                                            ? String(packData.price[itnKey].price.reserve)
                                            : ''
                                    }
                                    min={2}
                                    limit={7}
                                />
                            </div>
                        </div>
                        <div className='itineraryInDiv'>
                            <label className='itineraryLabel'>Higher Price</label>
                            <div className='itineraryInputDiv'>
                                <input
                                    value={packData.price[itnKey]?.price?.higherPrice || null}
                                    type='number'
                                    name='higherPrice'
                                    onChange={(e) => handlePrice(e, itnKey)}
                                    placeholder={`higherPrice Price for city ${itnKey + 1} `}
                                    className='itineraryInput'
                                ></input>
                                <CharCount
                                    string={
                                        packData?.price[itnKey]?.price?.higherPrice
                                            ? String(packData.price[itnKey].price.higherPrice)
                                            : ''
                                    }
                                    min={2}
                                    limit={7}
                                />
                            </div>
                        </div>
                        <div className='itineraryInDiv'>
                            <label className='itineraryLabel'>Discount Per Price</label>
                            <div className='itineraryInputDiv'>
                                <input
                                    value={packData.price[itnKey]?.price?.discountPer || null}
                                    type='number'
                                    name='discountPer'
                                    onChange={(e) => handlePrice(e, itnKey)}
                                    placeholder={`higherPrice Price for city ${itnKey + 1} `}
                                    className='itineraryInput'
                                ></input>
                                <CharCount
                                    string={
                                        packData?.price[itnKey]?.price?.discountPer
                                            ? String(packData.price[itnKey].price.discountPer)
                                            : ''
                                    }
                                    min={2}
                                    limit={7}
                                />
                            </div>
                        </div>

                        {packData.group === 'vehicle' && (
                            // <div className='itineraryInDiv vehicleDiv'>
                            //     <label className='itineraryLabel vehicleLable'>Vehicle</label>
                            //     <div className='itineraryInDiv'>
                            //         <label className='itineraryLabel'>Name</label>
                            //         <div className='itineraryInputDiv'>
                            //             <input
                            //                 value={packData.price[itnKey]?.price?.vehicle?.name}
                            //                 type='text'
                            //                 name='name'
                            //                 onChange={(e) => handlePrice(e, itnKey, true)}
                            //                 placeholder={`Vehicle name for city ${itnKey + 1} `}
                            //                 className='itineraryInput'
                            //             ></input>
                            //             {/* <CharCount
                            //                         string={
                            //                             packData.price[itnKey]
                            //                                 ? packData.price[itnKey].price.vehicle?.name
                            //                                 : 0
                            //                         }
                            //                         min={2}
                            //                         limit={7}
                            //                     /> */}
                            //         </div>
                            //     </div>
                            //     <div className='itineraryInDiv'>
                            //         <label className='itineraryLabel'>Price</label>
                            //         <div className='itineraryInputDiv'>
                            //             <input
                            //                 value={packData.price[itnKey]?.price?.vehicle?.price}
                            //                 type='number'
                            //                 name='price'
                            //                 onChange={(e) => handlePrice(e, itnKey, true)}
                            //                 placeholder={`Vehicle price for city ${itnKey + 1} `}
                            //                 className='itineraryInput'
                            //             ></input>
                            //             {/* <CharCount
                            //                         string={
                            //                             packData.price[itnKey]
                            //                                 ? packData.price[itnKey].price?.vehicle?.price
                            //                                 : 0
                            //                         }
                            //                         min={2}
                            //                         limit={7}
                            //                     /> */}
                            //         </div>
                            //     </div>
                            // </div>
                            <>
                                <div className='itineraryInDiv custom'>
                                    <label className='itineraryLabel'>Vehicle</label>
                                    <div className='itineraryDiv1'>
                                        {/* <input
                                            type='text'
                                            name='name'
                                            onChange={(e) =>
                                                setVehicle((prev) => ({
                                                    ...prev,
                                                    [e.target.name]: e.target.value
                                                }))
                                            }
                                            placeholder='Vehicle name'
                                            value={vehicle.name}
                                            className='nestedTagInput'
                                            // onKeyDown={(e) => {
                                            //     if (e.key === 'Enter') {
                                            //         addPickup();
                                            //     }
                                            // }}
                                        ></input> */}
                                        <div className='itineraryInputDiv'>
                                            <select
                                                value={vehicle.name}
                                                name='name'
                                                onChange={(e) =>
                                                    setVehicle((prev) => ({
                                                        ...prev,
                                                        [e.target.name]: e.target.value
                                                    }))
                                                }
                                                className='nestedTagInput'
                                            >
                                                <option value='-1'>Select</option>
                                                {vehicles
                                                    .filter((val) => !selectedVehicles.includes(val.name))
                                                    .map(function (val, typeIndex) {
                                                        return (
                                                            <option key={typeIndex} value={val.name}>
                                                                {val.displayName}
                                                            </option>
                                                        );
                                                    })}
                                            </select>
                                        </div>
                                        <div className='itineraryInputDiv'>
                                            <input
                                                type='number'
                                                name='price'
                                                onChange={(e) =>
                                                    setVehicle((prev) => ({
                                                        ...prev,
                                                        [e.target.name]: e.target.value
                                                    }))
                                                }
                                                placeholder='Vehicle Price'
                                                value={vehicle.price}
                                                className='nestedTagInput'
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        addVehicle(itnKey);
                                                    }
                                                }}
                                            ></input>
                                            <button
                                                type='button'
                                                onClick={() => addVehicle(itnKey)}
                                                className='nestedTagOkBtn blueBtn'
                                            >
                                                Add Vehicle
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                {packData?.price[itnKey]?.vehicle?.length > 0 && (
                                    <div className='tagContainer'>
                                        <div className='tagOutDiv'>
                                            {packData.price[itnKey].vehicle.map((text, index) => {
                                                return (
                                                    <div key={index} className='tagDiv'>
                                                        <p className='tagP'>{text.name}</p>
                                                        <button
                                                            className='tagButton'
                                                            onClick={(e) => removeVehicle(text, itnKey)}
                                                        >
                                                            X
                                                        </button>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                )}{' '}
                            </>
                        )}
                        <div className={`itineraryInDiv ${packData.group === 'vehicle' ? 'startCity' : ''}`}>
                            <label className='itineraryLabel'>Start City</label>
                            <div className='itineraryInputDiv'>
                                <select
                                    value={packData.price[itnKey] ? packData.price[itnKey].startCity : ''}
                                    name='startCity'
                                    onChange={(e) => handlePrice(e, itnKey)}
                                    className='citySelectPrice'
                                >
                                    <option value='-1'>Select</option>
                                    {cityDrop.map(function (val, typeIndex) {
                                        return (
                                            <option key={typeIndex} value={val.name}>
                                                {val.displayName}
                                            </option>
                                        );
                                    })}
                                </select>
                            </div>
                        </div>
                        <NestedTags packData={packData} setPackData={setPackData} index={itnKey} />
                        {packData.price[itnKey]?.price?.reserve <= 0 && (
                            <Installment packData={packData} setPackData={setPackData} index={itnKey} />
                        )}
                    </div>
                );
            })}
        </>
    );
}
